import { mergeTranslations } from "ra-core";
import polyglotI18nProvider from "ra-i18n-polyglot";
import englishMessages from "ra-language-english";

const allEnglishMessages = mergeTranslations(englishMessages);

export const i18nProvider = polyglotI18nProvider(
    _ => allEnglishMessages,
    "en",
);
